import { AlignHorizontalLeft } from "@mui/icons-material";
import { AppRoutes } from "../../router/routes";

export const mandateKeys = [
    { parentKey: "basic_details", childKey: "name" },
    { parentKey: "basic_details", childKey: "description" },
    { parentKey: "basic_details", childKey: "prompt_text" }
];

export const NavBars = (id: string, isEdit: boolean) => ([
    {
        id: "1",
        title: "Basic Details",
        icon: <AlignHorizontalLeft fontSize="small" />,
        path: AppRoutes.viewSearchPromptBasicDetails(id)
    }  
])